import dayjs from 'dayjs';
import React, { useState } from 'react';
import DownloadCSV from '~components/molecules/DownloadCSV';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import UtilFunctions from '~utils/functions';
import { FundTypeEnum } from '~utils/enums';

const InventoryDeliveredExportCSV = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const inventoryDeliveredListing = useAppSelector(state => state.gold.inventoryDeliveredListingForExport);
    const exportInventoryDeliveredIsLoading = useAppSelector(state => state.gold.loadings.exportInventoryDeliveredListing);

    const exportInventoryDelivered = () => dispatch(combinedActions.goldExportInventoryDeliveredListingAttempt());
    const clearInventoryDeliveredListingForExport = () => dispatch(combinedActions.goldClearInventoryDeliveredListingForExport());

    const [isExportingInventoryDeliveredListing, setIsExportingInventoryDeliveredListing] = useState<boolean>(false);

    const handleExportInventoryDeliveredListingCleanup = () => {
        clearInventoryDeliveredListingForExport();
        setIsExportingInventoryDeliveredListing(false);
    };

    const listHeader = [
        'PRODUCT NAME',
        'DELIVERED TO',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
        'FUND TYPE',
        'DELIVERED AT',
    ];

    const listData = inventoryDeliveredListing.map(inventory => {
        const {
            product,
            to,
            serialNumbers,
            quantity,
            totalGoldWeight, // 👈 add
            fundType,
            createdAt,
        } = inventory;

        const massagedSerialNumbers = serialNumbers.map(serial => serial.serialNo).filter(item => item);

        return [
            product.productName,
            to.branchName,
            massagedSerialNumbers.join(', '),
            quantity,
            totalGoldWeight,
            FundTypeEnum[fundType],
            dateTimeFormat(createdAt),
        ];
    });

    return (
        <DownloadCSV
            buttonLabel='Export to CSV'
            header={listHeader}
            data={listData}
            fileName={dayjs().format('DD-MM-YYYY').concat(' Inventory Delivered')}
            onClick={exportInventoryDelivered}
            cleanup={handleExportInventoryDeliveredListingCleanup}
            isLoading={exportInventoryDeliveredIsLoading || isExportingInventoryDeliveredListing}
        />
    );
};

export default InventoryDeliveredExportCSV;
